export const uploadReport = (payload?: any) => ({
    type: "@saga/UPLOAD_REPORT",
    payload
});

